import { useFormContext } from "react-hook-form";
import { components, OptionProps } from "react-select";
import { styled } from "~/application/theme";

const StyledOption = styled(components.Option, {
  // Reset
  boxSizing: "border-box",
  display: "flex",

  // Custom
  padding: "$3 $4",
  width: "100%",
});

const SelectOptionRoot = styled("div", {
  // Reset
  all: "unset",
  display: "flex",
  position: "relative",

  // Custom
  userSelect: "none",
  fontSize: "$sm",
  lineHeight: "1",
  fontWeight: "500",
  color: "$neutral-500",
  transition: "$normal",

  "&[data-disabled=true]": {
    pointerEvents: "none",
    opacity: 0.5,
    cursor: "not-allowed",
  },

  "&:hover": {
    cursor: "pointer",
    backgroundColor: "$neutral-100",
  },

  "&:active": {
    color: "$neutral-900",
    backgroundColor: "$neutral-100",
  },

  "&[data-checked=true]": {
    color: "$primary-600",
    backgroundColor: "$primary-100",
  },
});

export const SelectOption = (props: OptionProps) => {
  const { watch } = useFormContext();
  const dataCy = watch("dataCy");
  return (
    <SelectOptionRoot
      data-checked={props.isSelected}
      data-disabled={props.isDisabled}
      data-cy={`${dataCy}-option`}
    >
      <StyledOption {...props} />
    </SelectOptionRoot>
  );
};

SelectOption.displayName = "SelectOption";
